export default __webpack_public_path__ + "static/media/photo--lg--63.2ba10f36.jpg";